export const DEFAULT_PHONE_AUTH_ERROR_DESCRIPTION =
  '요청 처리 중 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.';

type PhoneAuthErrorToast = {
  title: string;
  description: string;
  variant: 'error';
};

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

const getApiErrorMessage = (error: unknown) => {
  if (!isRecord(error)) return undefined;

  const response = error.response;
  if (!isRecord(response)) return undefined;

  const data = response.data;
  if (!isRecord(data)) return undefined;

  const message = data.message;
  return typeof message === 'string' && message.length > 0 ? message : undefined;
};

export const getPhoneAuthErrorToast = (error: unknown): PhoneAuthErrorToast => {
  return {
    title: '인증 요청에 실패했습니다.',
    description: getApiErrorMessage(error) ?? DEFAULT_PHONE_AUTH_ERROR_DESCRIPTION,
    variant: 'error',
  };
};
